// @ts-nocheck
/* eslint-disable */
export const sideNavigationIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor"><path d="M180-120q-24 0-42-18t-18-42v-600q0-24 18-42t42-18h600q24 0 42 18t18 42v600q0 24-18 42t-42 18H180Zm300-60h300v-600H480v600Z"/></svg>`,
    name: 'side-navigation' as const
};